import React, { useState } from "react";
import OwlCarousel from "react-owl-carousel";
import Slider from "react-slick";
import BannerSlider from "./Slider/BannerSlider";

const products = [
  {
    id: 1,
    defaultImg: "images/prd-1.png",
    hoverImg: "images/prd-2.png",
    rating: 4.4,
    soldOut: true,
    stock: true,
    name: "Astronet Cotton Blended Regular Tops",
    color: "Black",
    price: 30,
    originalPrice: 70,
    discount: 63,
    colors: ["#fbc101", "#b41e4e", "#fd152d"],
  },
  {
    id: 2,
    defaultImg: "images/hero-2.png",
    hoverImg: "images/hero-4.png",
    rating: 4.2,
    soldOut: false,
    stock: true,
    name: "Formal Dresses",
    color: "Red",
    price: 45,
    originalPrice: 80,
    discount: 44,
    colors: ["#b41e4e", "#fbc101", "#fd152d"],
  },
  {
    id: 3,
    defaultImg: "images/hero-4.png",
    hoverImg: "images/hero-5.png",
    rating: 4.7,
    soldOut: false,
    stock: true,
    name: "Plus Size",
    color: "Blue",
    price: 60,
    originalPrice: 95,
    discount: 37,
    colors: ["#0057b7", "#b41e4e", "#fd152d"],
  },
  {
    id: 4,
    defaultImg: "images/hero-5.png",
    hoverImg: "images/prd-1.png",
    rating: 4.5,
    soldOut: false,
    stock: false,
    name: "Clothing",
    color: "Green",
    price: 50,
    originalPrice: 90,
    discount: 44,
    colors: ["#008000", "#fbc101", "#fd152d"],
  },
  {
    id: 5,
    defaultImg: "images/hero-3.png",
    hoverImg: "images/prd-2.png",
    rating: 4.3,
    soldOut: true,
    stock: false,
    name: "Just Arrived",
    color: "Yellow",
    price: 55,
    originalPrice: 85,
    discount: 35,
    colors: ["#fbc101", "#b41e4e", "#fd152d"],
  },
];
const bridalProducts = [
  {
    id: 1,
    title: "Carmine Red Designer Bridal Lehenga",
    color: "Black",
    price: 30,
    originalPrice: 70,
    discount: "63% Off",
    rating: 4.4,
    status: ["Sold-Out", "Stock"],
    images: {
      default: "images/bridal-lehenga/bridal-lehenga-1.jpg",
      hover: "images/bridal-lehenga/bridal-lehenga-hover.jpg",
    },
    colors: [
      {
        value: "white",
        color: "#b4000e",
        colorCode: "#b4000e",
        image: "images/bridal-lehenga/bridal-lehenga-1.jpg",
      },
      {
        value: "black",
        color: "#efc2c4",
        colorCode: "#efc2c4",
        image: "images/bridal-lehenga/bridal-lehenga-1.1.jpg",
      },
      {
        value: "red",
        color: "#fd152d",
        colorCode: "#fd152d",
        image: "images/bridal-lehenga/bridal-lehenga-1.2.jpg",
      },
    ],
  },
  {
    id: 2,
    title: "Carmine Red Designer Bridal Lehenga",
    color: "Black",
    price: 30,
    originalPrice: 70,
    discount: "63% Off",
    rating: 4.4,
    status: ["Sold-Out", "Stock"],
    images: {
      default: "images/bridal-lehenga/bridal-lehenga-2.jpg",
      hover: "images/bridal-lehenga/bridal-lehenga-hover.jpg",
    },
    colors: [
      {
        value: "white",
        color: "#b4000e",
        colorCode: "#b4000e",
        image: "images/bridal-lehenga/bridal-lehenga-2.jpg",
      },
      {
        value: "black",
        color: "#efc2c4",
        colorCode: "#efc2c4",
        image: "images/bridal-lehenga/bridal-lehenga-1.1.jpg",
      },
      {
        value: "red",
        color: "#fd152d",
        colorCode: "#fd152d",
        image: "images/bridal-lehenga/bridal-lehenga-1.2.jpg",
      },
    ],
  },
  {
    id: 3,
    title: "Carmine Red Designer Bridal Lehenga",
    color: "Black",
    price: 30,
    originalPrice: 70,
    discount: "63% Off",
    rating: 4.4,
    status: ["Sold-Out", "Stock"],
    images: {
      default: "images/bridal-lehenga/bridal-lehenga-3.jpg",
      hover: "images/bridal-lehenga/bridal-lehenga-hover.jpg",
    },
    colors: [
      {
        value: "white",
        color: "#b4000e",
        colorCode: "#b4000e",
        image: "images/bridal-lehenga/bridal-lehenga-3.jpg",
      },
      {
        value: "black",
        color: "#efc2c4",
        colorCode: "#efc2c4",
        image: "images/bridal-lehenga/bridal-lehenga-1.1.jpg",
      },
      {
        value: "red",
        color: "#fd152d",
        colorCode: "#fd152d",
        image: "images/bridal-lehenga/bridal-lehenga-1.2.jpg",
      },
    ],
  },
  {
    id: 4,
    title: "Carmine Red Designer Bridal Lehenga",
    color: "Black",
    price: 30,
    originalPrice: 70,
    discount: "63% Off",
    rating: 4.4,
    status: ["Sold-Out", "Stock"],
    images: {
      default: "images/bridal-lehenga/bridal-lehenga-4.jpg",
      hover: "images/bridal-lehenga/bridal-lehenga-hover.jpg",
    },
    colors: [
      {
        value: "white",
        color: "#b4000e",
        colorCode: "#b4000e",
        image: "images/bridal-lehenga/bridal-lehenga-4.jpg",
      },
      {
        value: "black",
        color: "#efc2c4",
        colorCode: "#efc2c4",
        image: "images/bridal-lehenga/bridal-lehenga-1.1.jpg",
      },
      {
        value: "red",
        color: "#fd152d",
        colorCode: "#fd152d",
        image: "images/bridal-lehenga/bridal-lehenga-1.2.jpg",
      },
    ],
  },
];

const firstViewSlider = [
  {
    image: "images/first-view-1.png",
    alt: "Just Arrived",
    title: "Just Arrived",
    link: "#",
    className: "tcolor",
  },
  {
    image: "images/first-view-2.png",
    alt: "Clothing",
    title: "Clothing",
    link: "#",
    className: "",
  },
  {
    image: "images/first-view-3.png",
    alt: "Plus Size",
    title: "Plus Size",
    link: "#",
    className: "green",
  },
];

const productStyle = {
  height: "480px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  padding: "10px",
  boxSizing: "border-box",
  background: "#fff",
  border: "1px solid #eee",
  margin: "0 10px",
};

const productImgStyle = {
  height: "280px",
  position: "relative",
  overflow: "hidden",
};

const productImgTagStyle = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
};

const Home = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 2,
    arrows: false,
    appendDots: (dots) => (
      <div
        style={{
          backgroundColor: "white",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <ul
          style={{
            margin: 0,
            padding: 0,
            display: "flex",
            justifyContent: "center",
            listStyle: "none",
          }}
        >
          {dots}
        </ul>
      </div>
    ),
    customPaging: (i) => <div className="custom-dot" />,
  };

  const [bridalCurrentImages, setBridalCurrentImages] = useState(
    bridalProducts.reduce((acc, product) => {
      acc[product.id] = product.images.default;
      return acc;
    }, {})
  );

  const handleColorChange = (productId, newImage) => {
    setBridalCurrentImages((prev) => ({
      ...prev,
      [productId]: newImage,
    }));
  };

  const firstViewSliderSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScrosll: 1,
    arrows: false,
  };

  return (
    <>
      <BannerSlider />

      <section className="main-section first-view-section pt-5 pb-5">
        <div className="container">
          <Slider {...firstViewSliderSettings}>
            {firstViewSlider.map((slide, index) => {
              const isLast = index === Number(firstViewSlider.length) - 1;
              // console.log(index === Number(firstViewSlider.length) - 1);
              return (
                <div key={index} className="item">
                  <div
                    className="first-view-box animation-hover object-fit wow fadeInUp"
                    style={{ marginRight: isLast ? "0" : "30px" }}
                  >
                    <a href={slide.link}>
                      <img src={slide.image} alt={slide.alt} />
                      <div className={`fv-content ${slide.className}`}>
                        <div>
                          <p>{slide.title}</p>
                          <u>Shop Now</u>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
      </section>

      <section className="main-section collage-section pt-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-sm-4 col-xs-hide fadeInUp">
              <div className="collage-box h-100 object-fit animation-hover">
                <img src="images/tranding.png" alt="tranding" />
              </div>
            </div>{" "}
            {/* col */}
            <div className="col-lg-8 col-sm-8 col-xs-12">
              <div className="row">
                <div className="col-lg-6 col-sm-6 col-xs-12 order-2 order-xs-1 pl-0 fadeInUp">
                  <div className="collage-box object-fit animation-hover">
                    <img src="images/print-tee.png" alt="GRAPHIC TEES" />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12 p-0 fadeInUp">
                  <div className="collage-box d-flex text-center align-items-center h-100">
                    <div className="collage-txt">
                      <h3 className="wow fadeInUp">GRAPHIC Tshirt</h3>
                      <p className="wow fadeInUp">
                        Essentially spurious message of the printing and
                        typesetting industry. Lorem Ipsum has been the business'
                        standard sham text since the 1500s, when an obscure
                        printer took a kitchen of type and blended it to make a
                        sort model book.
                      </p>
                      <a href="#" className="btn">
                        SHOP Tshirt
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-sm-6 col-xs-12 p-0 fadeInUp">
                  <div className="collage-box object-fit animation-hover">
                    <img src="images/basic-tee.png" alt="GRAPHIC Tshirt" />
                  </div>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12 p-0 fadeInUp">
                  <div className="collage-box d-flex text-center align-items-center h-100">
                    <div className="collage-txt">
                      <h3 className="wow fadeInUp"> THE BASICS SHOP </h3>
                      <p className="wow fadeInUp">
                        Essentially spurious message of the printing and
                        typesetting industry. Lorem Ipsum has been the business'
                        standard sham text since the 1500s, when an obscure
                        printer took a kitchen of type and blended it to make a
                        sort model book.
                      </p>
                      <a href="#" className="btn">
                        SHOP NOW{" "}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="main-section product-section pt-0">
        <div className="container" style={{ width: "100%", margin: "0 auto" }}>
          <div className="main-title text-center mb-5">
            <h3 className="heading">
              NEW <span>PRO</span>DUCTS
            </h3>
          </div>
          <Slider {...settings}>
            {products.map((product) => (
              <div
                key={product.id}
                className="item"
                style={{ outline: "none" }}
              >
                <div className="product" style={productStyle}>
                  <div
                    className="product-img object-fit"
                    style={productImgStyle}
                  >
                    <div className="status-bar">
                      <span className="prd-rating br-5 bg-darkgreen text-white">
                        {product.rating} <i className="lni lni-star" />
                      </span>
                      {product.soldOut && (
                        <span className="prd-stauts bg-site text-white br-5">
                          Sold-Out
                        </span>
                      )}
                      {product.stock && (
                        <span className="prd-stauts bg-green text-white br-5">
                          Stock
                        </span>
                      )}
                      <button className="wishlist-btn">
                        <i className="lni lni-heart" />
                      </button>
                    </div>
                    <a href="#">
                      <img
                        src={product.defaultImg}
                        alt="product"
                        className="prd-default-img"
                        style={productImgTagStyle}
                      />
                      <img
                        src={product.hoverImg}
                        alt="product-hover"
                        className="prd-hover-img"
                        style={productImgTagStyle}
                      />
                    </a>
                    <div className="quick-section">
                      <button
                        className="quick-btn"
                        data-toggle="modal"
                        data-target="#modalshow"
                      >
                        Quick View
                      </button>
                    </div>
                  </div>
                  <div className="prd-info">
                    <h4 className="prd-name">
                      <a href="#">
                        {product.name} -{" "}
                        <span className="prd-color">{product.color}</span>
                      </a>
                    </h4>
                    <div className="prices">
                      <span>${product.price}</span>{" "}
                      <del>${product.originalPrice}</del>{" "}
                      <span className="tcolor">{product.discount}% Off</span>
                    </div>
                    <div className="color-option">
                      <ul className="list-style">
                        {product.colors.map((color, idx) => (
                          <li key={idx} data-src={`images/prd-${idx + 1}.jpg`}>
                            <label>
                              <input
                                type="radio"
                                name={`color-option-${product.id}`}
                                defaultChecked={idx === 0}
                              />
                              <span
                                className="form-option-variant"
                                style={{ background: color }}
                              />
                            </label>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>

      <section class="video-section">
        <div class="videoPosition">
          <video autoplay="" loop="" muted="muted" poster="images/hero-1.jpg">
            <source src="images/video/market-location.mp4" type="video/mp4" />
          </video>
        </div>
        <div class="blend-txtt"> fashion Hub</div>
      </section>

      <section className="main-section product-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 col-sm-10 col-xs-12 m-auto">
              <div className="main-title text-center mb-5">
                <h3 className="heading"> Bridal Lehenga </h3>
                <p>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industry's
                  standard
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            {bridalProducts.map((bridalProduct) => (
              <BridalProductCard
                key={bridalProduct.id}
                bridalProduct={bridalProduct}
                bridalCurrentImage={bridalCurrentImages[bridalProduct.id]}
                handleColorChange={(newImage) =>
                  handleColorChange(bridalProduct.id, newImage)
                }
              />
            ))}
            <div className="col-lg-12 text-center pt-3">
              <a href="new-arrivals.html" className="btn">
                View All Products
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="offer-box">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 col-sm-6 col-xs-6 p-0">
              <div className="offer-box object-fit h-100 position-relative">
                <a href="#">
                  <img src="images/vinicius-wiesehofer.jpg" alt="offer-box" />
                </a>
                <div className="position-absolute offer-box-content d-flex align-items-center h-100">
                  <div>
                    <div className="offer-heading fs-80 text-white">SALE</div>
                    <h4 className="tcolor">250+ items only </h4>
                    <a href="#" className="btn bg-site">
                      Shop Sale
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-sm-6 col-xs-6 p-0">
              <div className="offer-box object-fit h-100 position-relative">
                <a href="#">
                  <img src="images/kids-offer-banner.jpg" alt="kids offer" />
                </a>
                <div className="position-absolute offer-box-content d-flex align-items-center h-100">
                  <div>
                    <div className="offer-heading fs-60 font-weight-bold text-white">
                      10% Off
                    </div>
                    <h4 className="tcolor">350+ items </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="main-section app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-sm-6 col-xs-12">
              <div className="mob-app wow fadeInRight text-center">
                <img src="images/app.png" alt="Fashion Hub App" />
              </div>
            </div>
            <div className="col-lg-6 col-sm-6 col-xs-12 align-self-center">
              <div className="mob-app-txt">
                <h3 className="wow fadeInLeft fs-50 heading">
                  Download <span>fashion</span> Hub <br />
                  App Now
                </h3>
                <p className="wow fadeInUp">
                  Fast, Simple &amp; Delightful.
                  <br />
                  All it takes is 30 seconds to Download.
                </p>
                <div className="app-btn mt-4">
                  <a href="#" className="wow fadeInUp">
                    <img
                      src="images/ios-app.png"
                      alt="Fashion Hub Appgoogle play"
                    />
                  </a>
                  <a href="#" className="wow fadeInUp">
                    <img
                      src="images/google-play.png"
                      alt="Fashion Hub Appgoogle play"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="main-section subscribe-section bg-fixed">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-sm-9 col-xs-12 m-auto">
              <div className="subscribe-form">
                <h3 className="wow fadeInUp">
                  Join the Design Center point mailing list
                </h3>
                <p>
                  Receive updates about sales, new products, and other great
                  deals.
                </p>
                <form>
                  <div className="form-group">
                    <input
                      type="email"
                      name="email"
                      className="form-control"
                      required=""
                      placeholder="Your Email Address"
                    />
                  </div>
                  <button type="submit" className="btn">
                    Subscribe
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="main-section feature">
        <div className="container">
          <div className="row">
            <div className="col-lg-7 col-sm-7 col-xs-12">
              <div className="row">
                <div className="col-lg-4 col-sm-4 col-xs-12">
                  <div className="feature-box">
                    <div className="feature-img">
                      <span className="mbri-delivery" />
                    </div>
                    <h6>Delivery</h6>
                    <p>within 3 to 7 days of the target.</p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-12">
                  <div className="feature-box">
                    <div className="feature-img">
                      <span className="mbri-update" />
                    </div>
                    <h6>Returns</h6>
                    <p>
                      Within ten days of delivery, merchandise with tags
                      attached may be returned..
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-sm-4 col-xs-12 footer-box-last">
                  <div className="feature-box">
                    <div className="feature-img">
                      <span className="mbri-lock" />
                    </div>
                    <h6>Safety</h6>
                    <p>Deliveries without contact for optimum security.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-sm-5 col-xs-12 feature-right">
              <div className="row">
                <div className="col-lg-6 col-sm-12 col-xs-12">
                  <div className="feature-box need-help">
                    <h6>Need Help?</h6>
                    <p>Our customer service departments are open.</p>
                    <div className="feature-timeing">
                      Mon-Sat [10:00 AM - 05:30 PM]{" "}
                    </div>
                    <div>
                      <a href="mailto:contact@gmail.com" className="link">
                        Contact Us{" "}
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-sm-12 col-xs-12">
                  <div className="feature-box need-help">
                    <h6>Where is my order?</h6>
                    <span className="mbri-map-pin" />
                    <a href="#" className="link">
                      Track my Order
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
const BridalProductCard = ({
  bridalProduct,
  bridalCurrentImage,
  handleColorChange,
}) => (
  <div className="col-lg-3 col-sm-3 col-xs-6">
    <div className="product">
      <div className="product-img object-fit">
        <div className="status-bar">
          <span className="prd-rating br-5 bg-darkgreen text-white">
            {bridalProduct?.rating} <i className="lni lni-star" />
          </span>
          <span className="prd-stauts bg-site text-white br-5">Sold-Out</span>
          <span className="prd-stauts bg-green text-white br-5">Stock</span>
          <button className="wishlist-btn">
            <i className="lni lni-heart" />
          </button>
        </div>
        <a href="#">
          <img
            src={bridalCurrentImage}
            alt="bridalProduct"
            className="prd-default-img"
          />
          <img
            src={bridalProduct.images.hover}
            alt=""
            className="prd-hover-img"
          />
        </a>
        <div className="quick-section">
          <button
            className="quick-btn"
            data-toggle="modal"
            data-target="#modalshow"
          >
            Quick View
          </button>
        </div>
      </div>
      <div className="prd-info">
        <h4 className="prd-name">
          <a href="#" tabIndex={0}>
            {bridalProduct.name}
            <span className="prd-color">{bridalProduct.color}</span>
          </a>
        </h4>
        <div className="prices">
          <span>${bridalProduct.price}</span>{" "}
          <del>${bridalProduct.originalPrice}</del>{" "}
          <span className="tcolor">{bridalProduct.discount}</span>
        </div>
        <div className="color-option">
          <ul className="list-style">
            {bridalProduct.colors.map((color, idx) => (
              <li key={idx} onClick={() => handleColorChange(color.image)}>
                <label>
                  <input
                    type="radio"
                    name={`color-option-${bridalProduct.id}`}
                  />
                  <span
                    className="form-option-variant"
                    style={{ background: color.color }}
                  />
                </label>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default Home;
